import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import WnnrLogo from "@assets/img/WnnrLogo.svg";

interface ThemeState {
  logoUrl?: string;
  logoImage1?: string;
  logoImage2?: string;
  logoImage3?: string;
  logoImage4?: string;
  name?: string;
}

const initialState: ThemeState = {
  logoUrl: "https://wnnr-bucket.fsn1.your-objectstorage.com/b77d8728-bf73-4bf8-8a8c-9aa229ef7f5b.jpg",
  logoImage1: "https://wnnr-bucket.fsn1.your-objectstorage.com/b77d8728-bf73-4bf8-8a8c-9aa229ef7f5b.jpg",
  logoImage2: undefined,
  logoImage3: undefined,
  logoImage4: undefined,
  name: "Dabur",
};


const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<ThemeState>) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setTheme } = themeSlice.actions;
const themeReducer = themeSlice.reducer;
export default themeReducer;